<template>
  <div class="loading-container">
    <transition name="fade">
      <div v-show="isLoading" v-bind:class="loadingClasses">
        <div v-if="greeking" class="greeking-container">
          <!-- Can be turned into a slot for custom greeking -->
          <div class="text line"></div>
          <div class="text line"></div>
          <div class="text"></div>
        </div>
        <svg
          v-if="!greeking"
          version="1.1"
          id="loader-1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          v-bind:width="svgSize"
          v-bind:height="svgSize"
          viewBox="0 0 50 50"
          xml:space="preserve"
        >
          <path
            v-bind:class="colorClasses"
            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
            transform="rotate(30.7716 25 25)"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            ></animateTransform>
          </path>
        </svg>
    </div>
     </transition>
    <transition name="fade">
      <Message v-show="!isLoading && hasError" type="error" :message="errorMessage" :inline="inlineMessages" />
    </transition>
    <transition name="fade">
      <Message v-show="!isLoading && !hasError && hasNoResults" :message="noResultsMessage" :inline="inlineMessages" />
    </transition>
    <transition name="fade">
      <div v-if="!isLoading && !hasError && !hasNoResults">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import Message from './Message';

export default {
  components: {
    Message
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hasNoResults: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    noResultsMessage: {
      type: String
    },
    inlineMessages: {
      type: Boolean,
      default: true,
    },
    greeking: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      validator: function(value) {
        return ['primary', 'secondary', 'alt-1', 'alt-2'].indexOf(value) !== -1;
      }
    },
    size: {
      type: String,
      validator: function(value) {
        return ['medium', 'small', 'large'].indexOf(value) !== -1;
      }
    },
    position: {
      type: String,
      validator: function(value) {
        return ['absolute', 'fixed'].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    loadingClasses: function() {
      return this.position === 'fixed' ? 'loading loading--fixed' : 'loading';
    },
    colorClasses: function() {
      return {
        'loading--primary': this.color === 'primary',
        'loading--secondary': this.color === 'secondary',
        'loading--alt-1': this.color === 'alt-1',
        'loading--alt-2': this.color === 'alt-2'
      };
    },
    svgSize: function() {
      switch (this.size) {
        case 'small':
          return '16px';
        case 'large':
          return '64px';
        default:
          return '32px';
      }
    }
  }
};
</script>